import { useEffect, useState } from 'react'
import { getPlansByOrder } from 'src/@api/dashboard'
import { mapRenewalPlans, resolvePlanIndex } from 'src/utils/renewalPlans'

/**
 * 拉取 plans-by-order 套餐并映射展示价。
 * - 常规续费：传 orderId
 * - 全部超 30 天：不传 order_id，后端返回新买产品/价格
 */
const useRenewalPlans = ({
  orderId,
  expireTime,
  productName,
  enabled = true,
  forceExpiredOver = false,
  omitOrderId = false,
  defaultMonths = 1
} = {}) => {
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(false)
  const [planIndex, setPlanIndex] = useState(0)

  useEffect(() => {
    const hasOrderId = orderId != null && orderId !== ''
    if (!enabled || (!omitOrderId && !hasOrderId)) {
      setPlans([])

      return undefined
    }

    let cancelled = false

    const load = async () => {
      setLoading(true)
      try {
        const params = omitOrderId || !hasOrderId ? {} : { order_id: orderId }
        const res = await getPlansByOrder(params)
        if (cancelled) return

        const list = res?.code === 0 && Array.isArray(res.data) ? res.data : []
        const mapped = mapRenewalPlans(list, expireTime, { forceExpiredOver })
        setPlans(mapped)
        setPlanIndex(resolvePlanIndex(mapped, productName, { defaultMonths }))
      } catch (error) {
        console.error('[useRenewalPlans] fetch failed', error)
        if (!cancelled) {
          setPlans([])
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()

    return () => {
      cancelled = true
    }
  }, [orderId, expireTime, productName, enabled, forceExpiredOver, omitOrderId, defaultMonths])

  const selectedPlan = plans[planIndex] || null

  return {
    plans,
    loading,
    planIndex,
    setPlanIndex,
    selectedPlan
  }
}

export default useRenewalPlans
